module.exports = __webpack_public_path__ + "images/duin-d0018858785cdb639c0f7afc2e32c6dd.jpg";